import { CellItem } from '@components/UI-Components/HierarchyWiseItemsTable/components/Row/Cell'
import useOrderContext from '@modules/order/hooks/use-order-context'
import useViewContext from '@modules/order/hooks/use-view-context'
import { PRODUCT_OPERATIONS_LOADERS } from '@modules/order/stores/view/List/ListDataStore'
import classNames from 'classnames'
import get from 'lodash/get'
import { useObserver } from 'mobx-react-lite'
import React, { FC } from 'react'
import { useEnhancedProductStatus } from '@components/UI-Components/ProductCard/ProductStatusHook'
import { getNumberFromLocale } from '@utils/get-number-form-locale'
import QtyNumberInput from '@modules/order/components/CellTemplates/components/QtyNumberInput/QtyNumberInput'
import FieldSkeleton from '@api/order/components/CellLoaders/FieldSkeleton'
import { EnhancedListUIStore } from '@modules/showroom/EnhancedOrder/stores/EnhancedListView/EnhancedListUIStore'
import { makeStyles } from '@material-ui/core'
import EnhancedCell from './EnhancedCell'

const useStyles = makeStyles(theme => ({
  inputBox: {
    width: 100,
    height: 20,
    marginTop: 0
  }
}))

const EnhancedProductQuantity: FC<CellItem> = ({ rowData, column }) =>
  useObserver(function useHook() {
    const {
      uiStore: { isOrderEditable }
    } = useOrderContext()
    const viewContextVal = useViewContext()
    const classes = useStyles()
    const isProductActive: boolean = useEnhancedProductStatus(rowData)

    if (!rowData) {
      return <FieldSkeleton />
    }
    const value = get(rowData, column.enhancedField)

    const uiStore = viewContextVal.uiStore as EnhancedListUIStore<any>

    const index = rowData?.id
      ? uiStore.dataStore.itemIndexObjectStore.getIndexByKey(rowData.id)
      : null
    const disabled = index
      ? uiStore.dataStore.itemIndexObjectStore.isObjectsDataLoading(
          index,
          index + 1,
          PRODUCT_OPERATIONS_LOADERS.UPDATING_DRAFT_QUANTITY
        )
      : false
    return (
      <EnhancedCell className={classNames('flex justify-center w-100')}>
        <QtyNumberInput
          id={rowData.id}
          className={classes.inputBox}
          onChange={e => {
            uiStore.updateProductQuantity(
              rowData?.id,
              getNumberFromLocale(e.target.value),
              {}
            )
          }}
          value={value || 0}
          disabled={disabled || !isOrderEditable || !isProductActive}
        />
      </EnhancedCell>
    )
  })

export default EnhancedProductQuantity
